import * as types from './constants';

export const getCharacteristicsList = (query = {}, filter = {}) => ({
    types: [
        types.GET_CHARACTERISTICS_LIST_REQUEST,
        types.GET_CHARACTERISTICS_LIST_SUCCESS,
        types.GET_CHARACTERISTICS_LIST_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/characteristics-table?` + Object.entries(query).map(([key, val]) => `${key}=${val}`).join('&'),
            method: 'GET',
        }),
});

export const getCharacteristicDetails = (characteristicId) => ({
    types: [
        types.GET_CHARACTERISTICS_DETAILS_REQUEST,
        types.GET_CHARACTERISTICS_DETAILS_SUCCESS,
        types.GET_CHARACTERISTICS_DETAILS_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/characteristics/${characteristicId}`,
            method: 'GET',
        }),
});

export const updateCharacteristic = (characteristicId, data) => ({
    types: [
        types.UPDATE_CHARACTERISTICS_DETAILS_REQUEST,
        types.UPDATE_CHARACTERISTICS_DETAILS_SUCCESS,
        types.UPDATE_CHARACTERISTICS_DETAILS_FAILURE,
    ],
    promise: api =>
        api({
            url: characteristicId ? `/api/v1/characteristic-table/row/${characteristicId}` : '/api/v1/characteristic-table/row',
            method: 'POST',
            body: data,
        }),
});
